import { Container, type ContainerProps } from "react-bootstrap";

type WrapperProps = {
  children: React.ReactNode;
  className?: string;
};

const Wrapper = ({
  children,
  className,
  ...props
}: WrapperProps & ContainerProps) => {
  return (
    <Container className={className} fluid={true} {...props}>
      {children}
    </Container>
  );
};

export default Wrapper;
